import React from "react";
import type { LinkProps } from "react-router-dom";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";

const UnstyledLinkWrapper = styled.div`
  & a {
    text-decoration: none;
    color: ${({ theme }) => theme.brandColor};
  }
`;

type UnstyledLinkProps = {
  children: React.ReactNode;
} & Pick<LinkProps, "to">;

export function LinkUnstyled({ to, children }: UnstyledLinkProps) {
  return (
    <UnstyledLinkWrapper>
      <Link to={to}>{children}</Link>
    </UnstyledLinkWrapper>
  );
}
